<script>
    import { fly } from 'svelte/transition';
    import { abr_state } from '../../stores.js';
</script>

{#if $abr_state === "CRITICAL"}
    <div id="abrAlertWrapper" transition:fly="{{ y: 50, duration: 500 }}">
        <div id='abrAlertMessage'>
            <span>Poor connection quality. Consider upgrading your network for a better experience.</span>
        </div>
    </div>
{/if}

<style>
    #abrAlertWrapper {
        position: fixed;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10000;
        margin: 1em;
    }

    #abrAlertMessage {
        font-family: "Helvetica", sans-serif;
        font-weight: 225;
        font-size: 17px;
        color: antiquewhite;
        background: #c0392bcc;
        padding: 0.8em 1.2em;
        border-radius: 10px;
        box-shadow: 0px 4px 12px rgba(0,0,0,0.3);
        margin: 0;
        display: flex;
        align-items: center;
        gap: 15px;
    }
</style>
